<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.group.title.detail') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.group.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.groupLarge') }}</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-radio-group v-model="form.groupLargeId" dense class="mt-0 pt-0">
            <v-radio
              v-for="(groupLarge, index) in view.groupList"
              :key="index"
              :label="groupLarge.groupLargeName.ja"
              :value="groupLarge.groupLargeId"
              :id="`groupLargeId-${groupLarge.groupLargeId}`"
            ></v-radio>
          </v-radio-group>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.groupSmall') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.groupSmallNameJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.groupSmallNameJp')"
            id="groupSmallNameJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.groupSmallNameEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.groupSmallNameEn')"
            id="groupSmallNameEn"
            solo
            class="mt-2"
            maxlength="50"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.companyLabel') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.companyLabelJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.companyLabelJp')"
            id="companyLabelJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.companyLabelEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.companyLabelEn')"
            id="companyLabelEn"
            solo
            class="mt-2"
            maxlength="50"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.branchLabel') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.branchLabelJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.branchLabelJp')"
            id="branchLabelJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.branchLabelEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.branchLabelEn')"
            id="branchLabelEn"
            solo
            class="mt-2"
            maxlength="50"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.displayOrder') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.displayOrder"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.displayOrder')"
            id="displayOrder"
            solo
            maxlength="2"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.mst.group.label.accountEntryDisplayFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.accountEntryDisplayFlg"
          :label="$t('message.admin.mst.group.ph.accountEntryDisplayFlg')"
          id="accountEntryDisplayFlg"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.mst.group.label.accountEntryAddCompanyFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.accountEntryAddCompanyFlg"
          :label="$t('message.admin.mst.group.ph.accountEntryAddCompanyFlg')"
          id="accountEntryAddCompanyFlg"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.mst.group.label.adminUpdFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.adminUpdFlg"
          :label="$t('message.admin.mst.group.ph.adminUpdFlg')"
          id="adminUpdFlg"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">{{ $t('message.admin.mst.group.button.back') }}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goModify">{{ $t('message.admin.mst.group.button.modify') }}</mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goList" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.group.title.delete') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          {{ $t('message.admin.mst.group.desc.delete.text1') }}
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <div>
          <mp-button red wide @click.stop="dialog.deleteConfirm = true">{{ $t('message.admin.mst.group.button.delete') }}</mp-button>
        </div>
        <mp-dialog delete confirm :show="dialog.deleteConfirm" @clickOk="goDelete" @clickCancel="dialog.deleteConfirm = false"/>
        <mp-dialog delete :show="dialog.deleteComplete" @clickOk="goList" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import MpError from '@/components/item/MpError'
import { AdminMstGroup, Common } from '@/api'

export default {
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    groupSmallId: 0,
    view: {
      groupList: [],
      errors: []
    },
    form: {
      groupLargeId: null,
      groupSmallNameJp: null,
      groupSmallNameEn: null,
      companyLabelJp: null,
      companyLabelEn: null,
      branchLabelJp: null,
      branchLabelEn: null,
      displayOrder: null,
      accountEntryDisplayFlg: null,
      accountEntryAddCompanyFlg: null,
      adminUpdFlg: null
    },
    dialog: {
      modifyComplete: false,
      deleteConfirm: false,
      deleteComplete: false
    }
  }),
  computed: {
  },
  methods: {
    goList () {
      this.$router.push({ path: '/admin/mst/group/list' })
    },
    async goModify () {
      await AdminMstGroup.update({
        ...this.form,
        accountEntryDisplayFlg: this.form.accountEntryDisplayFlg ? 0 : 1, // DB上は"表示フラグ"なので画面の値を反転させる
        accountEntryAddCompanyFlg: this.form.accountEntryAddCompanyFlg ? 1 : 0,
        adminUpdFlg: this.form.adminUpdFlg ? 1 : 0,
        groupSmallId: this.groupSmallId
      })
        .then(() => {
          this.dialog.modifyComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async goDelete () {
      await AdminMstGroup.delete({ groupSmallId: this.groupSmallId })
        .then(() => {
          this.dialog.deleteConfirm = false
          this.dialog.deleteComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    }
  },
  created: async function () {
    // グループ小分類IDの取得
    this.groupSmallId = this.$route.params.id
    this.view.groupList = await Common.groupList()
    const groupSmallDto = this.view.groupList
      .flatMap(groupLarge => groupLarge.groupSmallList)
      .find(groupSmall => groupSmall.groupSmallId === Number(this.groupSmallId))
    if (groupSmallDto === undefined) {
      // 存在しないグループID
      this.view.errors.push({ msg: 'notExist', param: 'groupSmallId', errorType: 'validation' })
      return
    }
    this.form = {
      ...groupSmallDto,
      groupSmallNameJp: groupSmallDto.groupSmallName.ja,
      groupSmallNameEn: groupSmallDto.groupSmallName.en,
      companyLabelJp: groupSmallDto.companyLabel.ja,
      companyLabelEn: groupSmallDto.companyLabel.en,
      branchLabelJp: groupSmallDto.branchLabel.ja,
      branchLabelEn: groupSmallDto.branchLabel.en,
      accountEntryDisplayFlg: groupSmallDto.accountEntryDisplayFlg !== '1', // DB上は"表示フラグ"なので画面の値は反転させる
      accountEntryAddCompanyFlg: groupSmallDto.accountEntryAddCompanyFlg === '1',
      adminUpdFlg: groupSmallDto.adminUpdFlg === '1'
    }
  }
}
</script>

<style scoped>
</style>
